import { ApiError } from '@/lib/api-errors';
import { api } from '@/lib/api';

const PAGE_SIZE = 100;
const HARD_LIMIT = 10_000;

export interface CustomReportExportResult {
  columns: string[];
  rows: Record<string, unknown>[];
}

/** Loads every row for a custom report (capped), for PDF export. */
export const fetchCustomReportForExport = async (input: {
  reportId: string;
}): Promise<CustomReportExportResult> => {
  const rows: Record<string, unknown>[] = [];
  let page = 1;
  let totalPages = 1;
  let columns: string[] = [];

  while (page <= totalPages && rows.length < HARD_LIMIT) {
    const result = await api.get<{
      columns: string[];
      rows: Record<string, unknown>[];
      page: { page: number; pageSize: number; totalItems: number; totalPages: number };
    }>(`/reports/custom/${input.reportId}/run`, {
      query: { page, pageSize: PAGE_SIZE },
    });

    columns = result.columns;

    if (page === 1 && result.page.totalItems > HARD_LIMIT) {
      throw new ApiError(413, { error: { code: 'EXPORT_TOO_LARGE' } });
    }

    rows.push(...result.rows);
    totalPages = result.page.totalPages;
    if (result.rows.length === 0) break;
    page += 1;
  }

  if (rows.length >= HARD_LIMIT) {
    throw new ApiError(413, { error: { code: 'EXPORT_TOO_LARGE' } });
  }

  return { columns, rows };
};
